import { PurchaseOrderReference } from './../PurchaseOrderStore';
import { SaleItemReference } from './../SaleItemStore';
import { ProductReference } from '../products/ProductStore';
import { JournalReference } from './JournalStore';
import {
  types,
  SnapshotIn,
  SnapshotOut,
  Instance,
  IAnyModelType,
  getRoot,
} from 'mobx-state-tree';
import { DateTime } from '../DateTime';
import { RootModelType } from '../Root';
import { modelWithCRUD } from '../utils/modelWithCRUD';
import { LocationReference } from './LocationStore';

export const ProductEntry = types.model('ProductEntry', {
  id: types.union(types.identifier, types.identifierNumber),
  created_at: DateTime,
  updated_at: types.maybeNull(DateTime),
  location: types.late(() => LocationReference),
  journal: types.late(() => JournalReference),
  product: types.late(() => ProductReference),

  quantity: types.number,
  committed: types.number,

  sale_item: types.maybeNull(types.late(() => SaleItemReference)),
  purchase_order_item: types.maybeNull(
    types.late(() => PurchaseOrderReference)
  ),
});

export const ProductEntryStore = modelWithCRUD(
  'product-entries',
  ProductEntry
).named('ProductEntryStore');

export interface IProductEntry extends Instance<typeof ProductEntry> {}
export interface IProductEntrySnapshotIn
  extends SnapshotIn<typeof ProductEntry> {}
export interface IProductEntrySnapshotOut
  extends SnapshotOut<typeof ProductEntry> {}

export const ProductEntryReference = types.reference(
  types.late((): IAnyModelType => ProductEntry),
  {
    get(identifier, parent): any {
      return (getRoot(parent!) as RootModelType).productEntryStore.getItemNaive(
        identifier
      );
    },
    set(value) {
      return value.id;
    },
  }
);
